import { render, staticRenderFns } from "./AlbaranV2.vue?vue&type=template&id=02884081&scoped=true&"
import script from "./AlbaranV2.vue?vue&type=script&lang=js&"
export * from "./AlbaranV2.vue?vue&type=script&lang=js&"
import style0 from "./AlbaranV2.vue?vue&type=style&index=0&id=02884081&prod&lang=scss&"
import style1 from "./AlbaranV2.vue?vue&type=style&index=1&id=02884081&prod&scoped=true&lang=css&"
import style2 from "./AlbaranV2.vue?vue&type=style&index=2&id=02884081&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02884081",
  null
  
)

export default component.exports